import type { CampaignBrandListApiData, CampaignListApiData } from '@navio/nsdk';
import { filterUnitFor, type SharedQuery, useFilterUnits } from 'noddi-ui-web';
import { useBrandOptions } from '../Brand/useBrandFilter';
import { CREATED_AT_FILTER_TEXT } from '../Date/useCreatedAtFilter';

// One unit set feeds whichever endpoint the list calls: the organization's campaigns or one brand's.
type CampaignListFilterInput = Omit<
  SharedQuery<NonNullable<CampaignListApiData['query']>, NonNullable<CampaignBrandListApiData['query']>>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search' | 'serviceOrganizationId' | 'brandId'
>;

const campaignFilterUnit = filterUnitFor<CampaignListFilterInput>();

export const useCampaignTableFilters = ({
  serviceOrganizationIds,
  includeBrandFilter = false
}: {
  serviceOrganizationIds?: number[];
  /** Partner org lists can span marketplace brands shown in the Campaign column. */
  includeBrandFilter?: boolean;
} = {}) => {
  const brands = useBrandOptions({ serviceOrganizationIds });

  return useFilterUnits([
    ...(includeBrandFilter
      ? [
          campaignFilterUnit.multiSelect('brandIds', {
            title: 'Brand',
            description: 'Filter by campaign brand',
            source: brands,
            exclude: true
          })
        ]
      : []),
    campaignFilterUnit.boolean('isForNewUserOnly', {
      title: 'New customers only',
      description: 'Only show campaigns limited to new customers'
    }),
    campaignFilterUnit.boolean('isExpired', {
      title: 'Expired',
      description: 'Only show expired or still-active campaigns'
    }),
    campaignFilterUnit.dateRange('createdAt', { ...CREATED_AT_FILTER_TEXT, exclude: true })
  ]);
};
